exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".dice{width:4rem;height:8rem;margin:4rem}.dice--active{position:relative;background:repeating-linear-gradient(-128deg,#ff0,orange,#ff4500)}.dice--active:before{content:\" \";border-style:solid;border-width:10px 15px 10px 0;border-color:transparent #dd6828 transparent transparent;position:absolute;right:-15px;top:1rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/home/home.scss
// module id = 455
// module chunks = 0